module.exports = __webpack_public_path__ + "static/media/FileUploadIcon.621d500a.svg";